












import IProductDto from "@/chipply/i-product-dto";
import { PriceDisplayHelper } from "@/chipply/helper/PriceDisplayHelper";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";
import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Prop } from "vue-property-decorator";

@Component({
    components: {},
})
export default class ProductPriceDisplay extends Vue {
    public name = "ProductPriceDisplay";
    private priceDisplayHelper = new PriceDisplayHelper();

    // eslint-disable-next-line
    @Prop({ type: Object, default: () => {} })
    public product!: IProductDto;

    @Prop({ type: Boolean })
    public highlightFirst!: boolean;

    @Prop({ type: Boolean })
    public bold!: boolean;

    @Prop({ type: Boolean })
    public isStartingPrice!: boolean;

    @Inject()
    private priceDisplay!: IPriceDisplay;

    public get displayPriceParts() {
        if (!this.priceDisplay) {
            return [];
        }
        if (this.isStartingPrice) {
            return this.priceDisplayHelper.getProductPriceDisplay(
                this.product,
                "starting",
                this.product.startingPrice,
                this.priceDisplay
            );
        } else {
            return this.priceDisplayHelper.getProductPriceDisplay(
                this.product,
                "base",
                this.product.basePrice,
                this.priceDisplay
            );
        }
    }

    public getPartClasses(index: number) {
        if (this.bold) {
            return {
                "font-weight-bold": this.highlightFirst && index === 0,
                "": this.highlightFirst && index !== 0,
            };
        }
    }
}
